module.exports = __webpack_public_path__ + "img/partner3.9d60db00.png";